<script lang="ts" setup>
import { HantecIcon } from '@hantecmarket/hantec-ui-widget'
import { onMounted, ref, computed } from 'vue'

import ChatBot from '@/components/ChatBot.vue'
import ShieldWhiteRed from '@/components/Icons/ShieldWhiteRed.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { getLanguage } from '@/helpers/language-helper'
import { getLoadedStateLower } from '@/services/lowerNavigationService'
import {
  getLoadedState as navLoadedState,
  isSponsorshipAtleticoPresent
} from '@/services/navigationService'
import { getLoadedState, useNavigationUpperData } from '@/services/upperNavigationService'
import { __, resolveRouteName } from '@/utils/utils'

import type { NavItem } from '@/types/types'

const openedLanguageMenu = ref(false)
const navData = ref<NavItem[]>([])
const isUpperLoaded = getLoadedState()
const isNavLoaded = navLoadedState() && getLoadedStateLower()
const isSponsorshipPersent = isSponsorshipAtleticoPresent()

const handleToggleSwitcher = () => {
  openedLanguageMenu.value = !openedLanguageMenu.value
}

const siteUrl = `${document.location.origin}/`
let lang: string = ''

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

const country = computed(() => {
  return getCookie('country') || ''
})

onMounted(async () => {
  lang =
    localStorage.getItem('lang') !== '' &&
    localStorage.getItem('lang') !== 'undefined' &&
    localStorage.getItem('lang') !== 'en'
      ? localStorage.getItem('lang') + '/'
      : ''
  const navItems = await useNavigationUpperData()
  navData.value = navItems.value
  if (country.value === 'KR' || getLanguage() === 'ko' || country.value === 'BR') {
    navData.value = navData.value.slice(0, -1)
  }
})

const getUrl = (url: string) => {
  return url.startsWith('http://') || url.startsWith('https://') ? url : siteUrl + lang + url
}

const getUrlNoLang = (url: string) => {
  return url.startsWith('http://') || url.startsWith('https://') ? url : siteUrl + url
}

const handleMouseOver = () => {
  const event = new CustomEvent('mouse-out-menu')
  window.dispatchEvent(event)
  const eventActive = new CustomEvent('close-menu')
  window.dispatchEvent(eventActive)
}

const isHtrader = (input: string): boolean => {
  return input.toLowerCase().includes('htrader')
}
</script>

<template>
  <div
    class="bg-hantec-secondary text-white px-5 py-2.5 items-center hidden 2lg:flex justify-between"
    @mouseover="handleMouseOver"
  >
    <ul v-if="isUpperLoaded" class="flex gap-[18px] nav-s">
      <li
        v-for="domain of navData"
        :key="`domain-un-${domain.url}`"
        :class="{ 'text-hantec-primary': domain.isactive, hidden: isHtrader(domain.url) }"
      >
        <a
          v-if="!isHtrader(domain.url)"
          :href="(getUrl(domain.url) + '/').toValidUrl()"
          >{{ domain.label }}</a
        >
        <!-- <span class="cursor-pointer" v-if="isHtrader(domain.url)" @click="navigateToLink(domain.url)">
          {{ domain.label }}
        </span> -->
      </li>
    </ul>
    <div v-if="!isUpperLoaded" class="animate-pulse w-screen-1/2" role="status">
      <div
        class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 max-w-[240px] mb-2.5 mx-auto"
      ></div>

      <span class="sr-only">{{ __('Loading...') }} </span>
    </div>

    <ul
      v-if="isNavLoaded"
      class="flex items-center gap-2.5 divide-x divide-white text-[14px] tracking-normal"
    >
      <ChatBot />

      <li class="pl-2.5 h-full">
        <a :href="resolveRouteName('balanceguard')" class="flex items-center gap-2.5">
          <ShieldWhiteRed></ShieldWhiteRed>

          {{ __('Balance Guard') }}
        </a>
      </li>

      <li class="pl-2.5 h-full">
        <a :href="resolveRouteName('platformSocial')" class="flex items-center gap-2.5">
          <HantecIcon></HantecIcon>

          {{ __('Hantec Social') }}
        </a>
      </li>

      <li class="pl-2.5 h-full" v-if="isSponsorshipPersent">
        <a :href="`/${lang}company/sponsorships/`" class="flex items-center gap-2.5">
          {{ __('Sponsorships') }}
        </a>
      </li>

      <li class="pl-2.5 h-full">
        <a :href="resolveRouteName('contact-us')" class="flex items-center gap-2.5">
          {{ __('Contact Us') }}
        </a>
      </li>

      <li :class="[openedLanguageMenu ? 'bg-white' : '']" class="pl-2.5 flex h-6">
        <LanguageSwitcher @toggleSwitcher="handleToggleSwitcher"></LanguageSwitcher>
      </li>
    </ul>
    <div v-if="!isNavLoaded" class="animate-pulse w-screen-1/2" role="status">
      <div
        class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 max-w-[240px] mb-2.5 mx-auto"
      ></div>

      <span class="sr-only">{{ __('Loading...') }} </span>
    </div>
  </div>
</template>
